import { globalInitState } from '@/utils'

const state = globalInitState()

const actions = {

}

const mutations = {
  PUSH_TO_HISTORY(state, route) {
    state.history.push(route)
  },
  SET_THEME(state, theme) {
    if (!theme) theme = 'light-theme'
    state.theme = theme
  },
  SET_ALERT(state, alert) {
    state.alert = alert
  },
  RESET_STATE(state) {
    Object.assign(state, globalInitState())
  }
}

export default {
  state,
  actions,
  mutations
}